import Vue from 'vue';
import Vuex, {StoreOptions} from 'vuex';

import {RootState} from './types';
import settings from './modules/settings';
import getters from './getters';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  modules: {
    settings
  },
  getters
};

export default new Vuex.Store<RootState>(store);
